import { generateDataItem } from '@app/helpers';
import {
    type ArtifactBreakdownResponse,
    type ArtifactMintDetails,
    type ArtifactMintDisplayItem,
} from '@app/store/types/artifacts';

export function artifactMintSelector(state) {
    const artifacts = state.artifacts.artifacts;

    const artifactMintDetails: ArtifactMintDetails = {};
    artifacts &&
        artifacts.forEach((artifact) => {
            artifactMintDetails[artifact.artifact_type] = generateDataItem().mintingData(artifact);
        });

    return artifactMintDetails;
}

export function userArtifactMintSelector(state) {
    const { userArtifacts } = state.artifacts;
    const userArtifactMintDetails: ArtifactMintDetails = {};

    userArtifacts &&
        Object.keys(userArtifacts).forEach((artifact) => {
            userArtifactMintDetails[artifact] = {
                ...generateDataItem().mintingData(userArtifacts[artifact]),
            };
        });

    return userArtifactMintDetails;
}

export function artifactMintDisplaySelector(state) {
    const { artifactMetadata, userArtifacts, artifactsBreakdown } = state.artifacts;

    const mintDisplayItem = {} as ArtifactMintDisplayItem;
    if (userArtifacts && userArtifacts.length > 0) {
        Object.keys(userArtifacts)?.forEach((artifact) => {
            const metadata = artifactMetadata[artifact];
            const userBreakdown = userArtifacts[artifact];
            const breakdown = artifactsBreakdown[artifact];

            const item = generateDataItem().mintDisplayItem(metadata, userBreakdown, breakdown);
            mintDisplayItem[artifact] = { ...item };
        });
    }

    return mintDisplayItem;
}

export function artifactMintBreakdownSelector(state) {
    const artifactsBreakdown = state.artifacts.artifactsBreakdown;
    const artifactMintBreakdown: ArtifactBreakdownResponse = {};
    artifactsBreakdown &&
        Object.keys(artifactsBreakdown).forEach((artifact) => {
            const item = artifactsBreakdown[artifact];
            artifactMintBreakdown[artifact] = { ...item };
        });

    return artifactMintBreakdown;
}

export function selectedArtifactIdSelector(state) {
    return state?.artifacts?.selectedArtifact?.artifactId;
}
